import AuthForm, { STATE_LOGIN } from 'components/AuthForm';
import React from 'react';
import { Card, Col, Row, Spinner } from 'reactstrap';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom'

class AuthPage extends React.Component {
  state = {
    isLogged:false,
  }

  componentDidMount(){
    if(this.props.auth.isLoggedIn){
      this.setState({
        isLogged:true,
      })
    }
  }

  handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      this.props.history.push('/login');
    } else {
      this.props.history.push('/signup');
    }
  };

  handleLogoClick = () => {
    this.props.history.push('/');
  };

  render() {
    if(this.state.isLogged){
      return <Redirect to='/'/>
    } else if(this.props.auth.isLoading){
      return <Spinner/>;
    }
    return (
      <Row
        style={{
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Col md={6} lg={4}>
          <Card body>
            <h2 className="text-center">Control de Flota</h2>
            <br/>
            <p className="text-center text-uppercase">Ingresar</p>
            <AuthForm
              authState={this.props.authState}
              onChangeAuthState={this.handleAuthState}
              onLogoClick={this.handleLogoClick}
            />
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  auth:state.auth,
})

export default connect(mapStateToProps)(AuthPage);
